import { useTranslate } from '@tolgee/react';

const ignoreDetailErrors: RPA.Shopee.DetailErrors[] = [
  'manualCancel',
  'abortFromImageCaptcha',
  'abortFromOTP',
];

const useTranslateErrorMsg = () => {
  const { t } = useTranslate();

  const translateErrMsg = (errMsg: string = '', error?: RPA.Shopee.DetailErrors) => {
    if (error && ignoreDetailErrors.includes(error)) {
      return '';
    }

    if (errMsg.includes('error_name_or_password_incorrect')) {
      return t('ViewShops.shoppe.code.5');
    }
    if (errMsg.includes('error_account_not_exist')) {
      return t('ViewShops.shoppe.code.2');
    }
    if (errMsg.includes('not allowed, use main account login')) {
      return t('ViewShops.shoppe.code.3');
    }
    if (errMsg.includes('request_overdue') || errMsg.includes('net::')) {
      return t('ViewShops.shoppe.code.4');
    }
    if (errMsg.includes('error_notfound')) {
      return t('ViewShops.shoppe.code.2');
    }
    if (errMsg.includes('error_perm')) {
      return t('ViewShops.shoppe.code.5');
    }
    if (errMsg.includes('error_api')) {
      return t('ViewShops.shoppe.code.6');
    }
    if (errMsg.includes('error_banned')) {
      return t('ViewShops.shoppe.code.7');
    }
    if (errMsg.startsWith('Request')) {
      return t('ViewShops.shoppe.code.4');
    }
    if (errMsg.includes('error_require_captcha')) {
      return t('ViewShops.shoppe.code.8');
    }
    if (errMsg.includes('error_send_vcode_fail')) {
      return t('ViewShops.shoppe.code.9');
    }
    if (errMsg.includes('error_need_phone_area_code')) {
      return t('ViewShops.shoppe.code.11');
    }
    if (errMsg.includes('ErrNoMerchantShop')) {
      return t('ViewShops.shoppe.code.12');
    }
    if (error === 'shopeeConfirmAuthFailed' || error === 'redirectShopeeAuthConfirmPageFailed') {
      return t('ViewShops.shoppe.code.4');
    }
    if (error === 'shopeeConfirmAuthWebviewClose') {
      return t('ViewShops.shoppe.code.10');
    }
    return t('ViewShops.shoppe.code.fallback');
  };

  return translateErrMsg;
};

export default useTranslateErrorMsg;
